// src/hooks/useFetchProducts.js
import { useState, useEffect, useCallback, useRef } from "react";
import { api } from "../api";

export default function useFetchProducts() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState(null);
  const isMounted = useRef(true);

  const loadProducts = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await api.getProducts(); // uses i18n.language inside
      if (!isMounted.current) return;

      // Optional: sanity check / normalize fields if backend varies
      const normalized = Array.isArray(data) ? data.map(p => ({
        id: p.id,
        category_id: p.category_id ?? 0,
        type: p.type,                      // "protein" | "carbs" | "veges" | "sauce"...
        name: p.name,                      // { ar, he }
        weight: Number(p.weight ?? 0),
        img_url: p.img_url,
        is_addon: Boolean(p.is_addon),
        addon_price: Number(p.addon_price ?? 0),
        addon_weight: Number(p.addon_weight ?? 0),
        base_price: Number(p.base_price ?? 0),
        available: p.available !== false,
      })) : [];

      setProducts(normalized);
    } catch (err) {
      if (!isMounted.current) return;
      setError(err);
    } finally {
      if (!isMounted.current) return;
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    isMounted.current = true;
    loadProducts();
    return () => { isMounted.current = false; };
  }, [loadProducts]);

  return { products, loading, error, refetch: loadProducts };
}
